import CloseIcon from "@mui/icons-material/Close";
import { Box, Card, CardContent, IconButton, Typography, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { cardContent, dayCard, mealBox, mealContentBox, mealContentText, mealHeader, mealHeaderText, menuPlanContainer, recipeItemBox, removeButton } from "../../styles/menuPlanStyles";
import { daysOfWeek, mealTimes } from "./utils";

const MenuPlanResponsive = ({ menuPlan, recipes, handleOpenModal, handleRemoveFromMenuPlan, isReadOnly = false }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box sx={menuPlanContainer(theme)}>
      {daysOfWeek.map((day) => (
        <Card key={day} sx={dayCard(theme)}>
          <CardContent sx={cardContent(theme)}>
            <Typography variant="h6" gutterBottom>
              {t(`tableHeaders.daysOfWeek.${day}`)}
            </Typography>

            {mealTimes.map((meal) => {
              // Get all menu plan items for this day and meal
              const mealPlanItems = menuPlan.filter((item) => item.day === day && item.meal === meal);

              return (
                <Box
                  key={meal}
                  sx={mealBox(theme)}
                  onClick={() => {
                    if (!isReadOnly) {
                      handleOpenModal(day, meal);
                    }
                  }}
                >
                  <Box sx={mealHeader(theme)}>
                    <Typography variant="body2" sx={mealHeaderText(theme)}>
                      {t(`tableHeaders.mealTimes.${meal}`)}
                    </Typography>
                  </Box>

                  <Box sx={mealContentBox(theme)}>
                    {mealPlanItems?.length > 0 &&
                      mealPlanItems.map((mealItem, index) => {
                        const recipe = recipes?.find((r) => r.id === mealItem.recipeId);
                        if (!recipe) return null;

                        const isLastItem = index === mealPlanItems.length - 1;

                        return (
                          <Box key={mealItem.recipeId} sx={recipeItemBox(theme, isLastItem)}>
                            {/* Maybe truncate text and tooltip if we want to save space? */}
                            {/* <Tooltip title={recipe.title} arrow placement="top"> */}
                            <Typography variant="body1" sx={mealContentText(theme, true)}>
                              {recipe.title}
                            </Typography>
                            {/* </Tooltip> */}
                            {!isReadOnly && (
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRemoveFromMenuPlan(mealItem.recipeId, day, meal);
                                }}
                                sx={removeButton(theme)}
                              >
                                <CloseIcon sx={{ fontSize: "0.8rem" }} />
                              </IconButton>
                            )}
                          </Box>
                        );
                      })}
                  </Box>
                </Box>
              );
            })}
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default MenuPlanResponsive;
